import * as A from '@/api';
import AbstractDashboardWidget from './abstractDashboardWidget';
import VisualizationDashboardWidget from './visualizationDashboardWidget';
import TextBlockDashboardWidget from './textBlockDashboardWidget';
import HeadingDashboardWidget from './headingDashboardWidget';
import DynamicFiltersDashboardWidget from './dynamicFiltersDashboardWidget';
import { graphql } from '@/utils/graphql';
import { logger } from '@/utils/logger';
import FileUploadDashboardWidget from './imageUploadDashboardWidget';

const ns = 'app.services.dashboardWidgetFactory';

export type ConstructorInput = {
  id: string;
  dashboardId: string;
  type: A.DashboardWidgetType;
  configurations: string;
  position: string;
  state: 'new' | 'clean' | 'dirty';
};

export default class DashboardWidgetFactory {
  static create(input: ConstructorInput): AbstractDashboardWidget {
    if (input.type === A.DashboardWidgetType.VISUALIZATION) {
      return new VisualizationDashboardWidget(input);
    } else if (input.type === A.DashboardWidgetType.TEXT_BLOCK) {
      return new TextBlockDashboardWidget(input);
    } else if (input.type === A.DashboardWidgetType.HEADING) {
      return new HeadingDashboardWidget(input);
    } else if (input.type === A.DashboardWidgetType.DYNAMIC_FILTERS) {
      return new DynamicFiltersDashboardWidget(input);
    } else if (input.type === A.DashboardWidgetType.IMAGE_UPLOAD) {
      return new FileUploadDashboardWidget(input);
    }
    throw new Error(`${ns}.create: Unsupported widget type ${input.type}`);
  }

  static async getDashboardWidgetsByDashboard(
    dashboardId: string,
  ): Promise<AbstractDashboardWidget[]> {
    logger.info(dashboardId, { label: `${ns}.getDashboardWidgetsByDashboard.dashboardId` });
    const data = await graphql('listDashboardWidgetsByDashboard', { dashboardId });
    return data.items.map((el) => {
      let configurations = el.configurations || '';
      if (!configurations) {
        // this is for backward compatibility because the configurations field did not exist in the past
        if (el.type === A.DashboardWidgetType.VISUALIZATION) {
          configurations = JSON.stringify({ visualizationId: el.componentId });
        } else if (el.type === A.DashboardWidgetType.TEXT_BLOCK) {
          configurations = JSON.stringify({ content: el.componentId });
        } else if (el.type === A.DashboardWidgetType.HEADING) {
          configurations = JSON.stringify({ content: el.componentId });
        }
      }
      return DashboardWidgetFactory.create({ ...el, configurations, state: 'clean' });
    });
  }
}
